var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot } from "vue";
import { provide, inject, watch, ref } from 'vue';
import usePreferences from '../../hooks/usePreferences';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AmadeusProvider',
    props: {
        params: { default: function () { return ({}); } },
        manageParams: { default: function () { return ({}); } },
        bookingParams: { default: function () { return ({}); } },
        scheduleParams: { default: function () { return ({}); } },
        statusParams: { default: function () { return ({}); } },
        companionPricing: { default: function (props) { var _a; return (_a = props.companionPricing) !== null && _a !== void 0 ? _a : []; } },
        destinationAlerts: { default: function () { return []; } },
        overrideActionUrl: { default: 'https://wav-digital-1.saas.amadeus.com/plnext/kenyaairwaysDX/Override.action' },
        refxBookingUrl: {},
        refxManageBookingUrl: {},
        checkinUrl: { default: 'https://uat.digital.airline.amadeus.com/kq/ssci' },
        fareFamilies: { default: function () { return [
                'CFFECOBIZ',
                'CFFBIZ',
            ]; } }
    },
    setup: function (__props) {
        var _a, _b;
        var props = __props;
        var currentParams = (_a = inject('amadeus-params')) !== null && _a !== void 0 ? _a : {};
        var mergedParams = ref(__assign(__assign({}, currentParams), ((_b = props.params) !== null && _b !== void 0 ? _b : {})));
        var state = usePreferences();
        watch([state.language, state.country], function (_a) {
            var lang = _a[0], country = _a[1];
            if (country) {
                mergedParams.value.COUNTRY_SITE = (country === 'GLOBAL' || !country) ? 'GLO' : country;
            }
            if (lang === null || lang === void 0 ? void 0 : lang.startsWith('zh')) {
                mergedParams.value.LANGUAGE = 'CN';
            }
            else if (lang === null || lang === void 0 ? void 0 : lang.startsWith('fr')) {
                mergedParams.value.LANGUAGE = 'FR';
            }
            else {
                mergedParams.value.LANGUAGE = 'GB';
            }
        }, { deep: true, immediate: true });
        provide('amadeus-params', mergedParams.value);
        provide('amadeus-booking-params', props.bookingParams);
        provide('amadeus-manage-params', props.manageParams);
        provide('amadeus-status-params', props.statusParams);
        provide('amadeus-schedule-params', props.scheduleParams);
        provide('amadeus-override-action-url', props.overrideActionUrl);
        provide('amadeus-checkin-url', props.checkinUrl);
        provide('amadeus-fare-families', props.fareFamilies);
        provide('amadeus-companion-pricing', props.companionPricing);
        provide('amadeus-refx-booking-url', props.refxBookingUrl);
        provide('amadeus-refx-manage-booking-url', props.refxManageBookingUrl);
        provide('preferences', state);
        provide('destination-alerts', props.destinationAlerts);
        return function (_ctx, _cache) {
            return _renderSlot(_ctx.$slots, "default");
        };
    }
});
